export const svgToBase64 = (svgString) => {
    const cleanedSvgString = svgString.replace(/\n/g, '').trim()
    const base64EncodedSvg = btoa(cleanedSvgString)
    return `data:image/svg+xml;base64,${base64EncodedSvg}`
}
export const svgToDataUri = (svgString) => {
    // 将SVG字符串中的特殊字符进行URL编码
    const encodedSvgString = svgString
    .replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/{/g, "%7B").replace(/}/g, "%7D").replace(/</g, "%3C").replace(/>/g, "%3E");
    const dataUri = `data:image/svg+xml;utf8,${encodedSvgString}`
    return dataUri;
}

export const updateSvgFill = (svgString, newColor) => {
    if (!/^#[0-9A-F]{6}$/i.test(newColor)) {
        return svgString
    }
    const updatedSvgString = svgString.replace(/fill="[^"]*"/g, `fill="${newColor}"`)
    return updatedSvgString
}
export const px2vw = (px) => `${(px / 750) * 100}vw`